import { ConsumptionData } from "@/types";

export const consumptionData: ConsumptionData = {
    energy_consumption: {
        "Value1": 82,
        "Value2": 7,
        "Value3": 6,
        "Value4": 5,
    },
    electrical_infrastructure: {
        "Jan": {
            "תחמ״שים": 20,
            "שנאים": 25,
            "מס׳ חדרים טרנספורמציה": 5
        },
        "Feb": {
            "תחמ״שים": 22,
            "שנאים": 27,
            "מס׳ חדרים טרנספורמציה": 7
        },
        "Mar": {
            "תחמ״שים": 24,
            "שנאים": 32,
            "מס׳ חדרים טרנספורמציה": 10
        },
        "Apr": {
            "תחמ״שים": 26,
            "שנאים": 37,
            "מס׳ חדרים טרנספורמציה": 15
        },
        "May": {
            "תחמ״שים": 35,
            "שנאים": 40,
            "מס׳ חדרים טרנספורמציה": 25
        },
        "Jun": {
            "תחמ״שים": 15,
            "שנאים": 20,
            "מס׳ חדרים טרנספורמציה": 10
        },
        "Jul": {
            "תחמ״שים": 12,
            "שנאים": 17,
            "מס׳ חדרים טרנספורמציה": 5
        },
        "Aug": {
            "תחמ״שים": 10,
            "שנאים": 15,
            "מס׳ חדרים טרנספורמציה": 5
        },
        "Sep": {
            "תחמ״שים": 12,
            "שנאים": 15,
            "מס׳ חדרים טרנספורמציה": 5
        },
        "Oct": {
            "תחמ״שים": 10,
            "שנאים": 17,
            "מס׳ חדרים טרנספורמציה": 8
        },
        "Nov": {
            "תחמ״שים": 22,
            "שנאים": 25,
            "מס׳ חדרים טרנספורמציה": 10
        },
        "Dec": {
            "תחמ״שים": 20,
            "שנאים": 25,
            "מס׳ חדרים טרנספורמציה": 10
        }
    },
    gas_emissions: {
        "Jan": {
            "פליטות גז״ח": 35
        },
        "Feb": {
            "פליטות גז״ח": 40
        },
        "Mar": {
            "פליטות גז״ח": 25
        },
        "Apr": {
            "פליטות גז״ח": 20
        },
        "May": {
            "פליטות גז״ח": 15
        },
        "Jun": {
            "פליטות גז״ח": 10
        },
        "Jul": {
            "פליטות גז״ח": 5
        },
        "Aug": {
            "פליטות גז״ח": 13
        },
        "Sep": {
            "פליטות גז״ח": 10
        },
        "Oct": {
            "פליטות גז״ח": 10
        },
        "Nov": {
            "פליטות גז״ח": 10
        },
        "Dec": {
            "פליטות גז״ח": 10
        }
    }
}